import JobErpClient from '@/api/Integracao/jobErp.client';

const client = new JobErpClient();

export default {
  namespaced: true,
  state: {
    lista: [],
    meta: { total: 0, page: 1, pageSize: 20, totalPages: 0 },
    selecionado: null,
    execucoes: [],
    execucoesMeta: { total: 0, page: 1, pageSize: 20, totalPages: 0 },
    carregando: false,
    executando: false,
  },
  mutations: {
    SET_LISTA(state, { data, meta }) {
      state.lista = data || [];
      state.meta = meta || state.meta;
    },
    SET_SELECIONADO(state, job) { state.selecionado = job; },
    SET_EXECUCOES(state, { data, meta }) {
      state.execucoes = data || [];
      state.execucoesMeta = meta || state.execucoesMeta;
    },
    SET_CARREGANDO(state, v) { state.carregando = !!v; },
    SET_EXECUTANDO(state, v) { state.executando = !!v; },
  },
  actions: {
    async listar({ commit }, params = {}) {
      commit('SET_CARREGANDO', true);
      try {
        const { data } = await client.listar(params);
        commit('SET_LISTA', data);
        return data;
      } finally {
        commit('SET_CARREGANDO', false);
      }
    },
    async buscarPorId({ commit }, id) {
      const { data } = await client.buscarPorId(id);
      commit('SET_SELECIONADO', data.data);
      return data.data;
    },
    async criar(_ctx, payload) {
      const { data } = await client.criar(payload);
      return data.data;
    },
    async atualizar(_ctx, { id, payload }) {
      const { data } = await client.atualizar(id, payload);
      return data.data;
    },
    async excluir(_ctx, id) {
      const { data } = await client.excluir(id);
      return data.data;
    },
    async executar({ commit }, id) {
      commit('SET_EXECUTANDO', true);
      try {
        const { data } = await client.executar(id);
        return data.data;
      } finally {
        commit('SET_EXECUTANDO', false);
      }
    },
    async listarExecucoes({ commit }, { id, params = {} }) {
      const { data } = await client.listarExecucoes(id, params);
      commit('SET_EXECUCOES', data);
      return data;
    },
    async buscarExecucao(_ctx, { id, execId }) {
      const { data } = await client.buscarExecucao(id, execId);
      return data.data;
    },
  },
};
